function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons/Pagination/First");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Pagination/First",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.6953125,16.5703125 C10.8984375,16.5703125 11.0703125,16.4921875 11.203125,16.359375 L17.390625,10.3125 C17.5390625,10.1640625 17.625,9.984375 17.625,9.7890625 C17.625,9.5859375 17.5390625,9.390625 17.390625,9.265625 L11.203125,3.2109375 C11.0625,3.078125 10.8984375,3 10.6953125,3 C10.2890625,3 9.9765625,3.3125 9.9765625,3.71875 C9.9765625,3.90625 10.0625,4.09375 10.1875,4.2265625 L15.875,9.7890625 L10.1875,15.3515625 C10.0625,15.484375 9.9765625,15.6640625 9.9765625,15.859375 C9.9765625,16.265625 10.2890625,16.5703125 10.6953125,16.5703125 Z M3.7109375,16.5703125 C3.9140625,16.5703125 4.0859375,16.4921875 4.2265625,16.359375 L10.4140625,10.3125 C10.5625,10.1640625 10.640625,9.984375 10.640625,9.7890625 C10.640625,9.5859375 10.5625,9.390625 10.4140625,9.265625 L4.21875,3.2109375 C4.0859375,3.078125 3.9140625,3 3.7109375,3 C3.3046875,3 3,3.3125 3,3.71875 C3,3.90625 3.078125,4.09375 3.203125,4.2265625 L8.890625,9.7890625 L3.203125,15.3515625 C3.078125,15.484375 3,15.6640625 3,15.859375 C3,16.265625 3.3046875,16.5703125 3.7109375,16.5703125 Z",
  id: "ic-first",
  fill: "#70707D",
  fillRule: "nonzero",
  transform: "translate(10.312500, 9.785156) rotate(-180.000000) translate(-10.312500, -9.785156) "
}));

var SvgFirst = function SvgFirst(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFirst, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/first.9ca433de.svg";
export { ForwardRef as ReactComponent };